export default __webpack_public_path__ + "static/media/winner1.442081c9.jpg";